import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import logo from '../images/logo.png';
import { CrackersContext } from "../CrackersContext";
import TextInput from "./TextInput";
import { isValidEmail } from "../CrackersUtil";
import { raisePostRequest } from "../AxiosAPI";

function ForgotPassword() {
    const {setShowErrorToastStatus, setToastBody, setIsZeroCasePage } = useContext(CrackersContext);
    const captionEmail = 'Enter your Email to reset password';
    const [email, setEmail] = useState('');
    const [emailValidation, setEmailValidation] = useState({});
    const [mailTriggered, setMailTriggered] = useState(false);

    useEffect(() => {
        setIsZeroCasePage(true);
    }, [])

    const validateEmail = async (email) => {
        const error = {};
        if (!email) {
            error.validation = false;
            error.reason = "Email is required";
        } else if (!isValidEmail(email)) {
            error.validation = false;
            error.reason = "Invalid Email";
        }
        if (Object.keys(error).length > 0) {
            setEmailValidation(error);
        } else {
            if(userNamecheck()) {
                setEmailValidation({ "validation": true});
            }
            
        }
    };

    const userNamecheck = async() => {
        const staus = await raisePostRequest(`/customer/user-name-check`, {"user_name" : email}, null, setShowErrorToastStatus, setToastBody);
        if(!staus.user_exist) {
            setEmailValidation({"reason" : "This account is not registered with us. If you don't have an account, kindly sign up with us.", "validation" : false});
            return false;
        }
        return true;
    };

    const resetPassword = async() => {
        const response = await raisePostRequest("/customer/reset-password", {"email_id" : email}, null, setShowErrorToastStatus, setToastBody);
        if(response.staus = "success") {
            setMailTriggered(true);
        }
    }

    return(
        <div style={{marginTop : "2%"}}>
            <Row>
                <Col md={3}></Col>
                <Col md={6}>
                    <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}} hidden={mailTriggered}>
                        <Row>
                            <Col md={3}>
                                <h3 style={{color : "#FF5C00"}}><img src={logo} alt="Logo" style={{height : "35px", marginRight : "-18px"}} />rackleCart</h3>
                            </Col>    
                        </Row>

                        <Row style={{marginTop : "2%"}}>
                            <Col md={6}>
                                <p style={{fontWeight : "bold"}}>Forgot your password? No worries — it happens to the best of us! Just enter your registered email address, and we’ll send you a secure link to create a new password.</p>
                                <ul>
                                    <li>
                                        <p>If you don’t receive the email, check your Spam / Promotions folder.</p>
                                    </li>
                                    <li>
                                        <p>Didn’t sign up with this email? Contact support at <a target="_blank" href="mailto:support@cracklecart.com">support@cracklecart.com</a>.</p>
                                    </li>
                                    <li>
                                        <p>For security, do not share the reset link with anyone.</p>
                                    </li>
                                </ul>
                            </Col>
                            <Col md={1}></Col>
                            <Col md={5}>
                                <Row>
                                    <TextInput caption={captionEmail}
                                                value={email}
                                                onChange={setEmail}
                                                validation={emailValidation}
                                                info={"We'll never share your Email to reset password"}
                                                onFocusCaption={"Email"}
                                                validator={validateEmail}
                                                isMultiLine={false} />
                                </Row>
                                <Row className="d-flex justify-content-end">
                                    <Col xs={6}></Col>
                                    <Col xs={6}>
                                        <Button onClick={resetPassword}>Send reset link</Button>
                                    </Col>
                                </Row>
                                <Row style={{marginTop : "10px"}}>
                                    <Col>
                                        <p>🔒 Your account security is important to us. The reset link will expire in 30 minutes for your safety.</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>

                    <div style={{background : "white", padding : "2% 2% 2% 2%", borderRadius : "10px"}} hidden={!mailTriggered}>
                        <Row>
                            <Col md={3}>
                                <h3 style={{color : "#FF5C00"}}><img src={logo} alt="Logo" style={{height : "35px", marginRight : "-18px"}} />rackleCart</h3>
                            </Col>    
                        </Row>
                        <Row style={{marginTop : "2%"}}>
                            <Col xs={12}>
                                <h4 style={{fontWeight : "bold"}}>Check your email</h4>
                                <p>We’ve sent a password reset link to {email}. Click the link to choose a new password. (Link expires in 30 minutes.)</p>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col md={3}></Col>
            </Row>
            
        </div>
    );
}

export default ForgotPassword;